// src/components/AxiosConfig.js
import axios from 'axios';
const host = window.location.hostname.toLowerCase();
let baseURL = '';
if (host ===  process.env.CONF_URL_ADN) {
  baseURL = process.env.REACT_APP_BACKEND_URL_ADN;
} else if (host === process.env.CONF_URL_PAP) {
  baseURL = process.env.REACT_APP_BACKEND_URL_PAP;
} 
const instance = axios.create({
  baseURL,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    'Content-Type': 'application/json',
  },
});
// (facoltativo ma utile per debug)
instance.interceptors.request.use((config) => {
  // puoi loggare il token attuale se vuoi controllare
  const token = document.cookie.match(/csrftoken=([^;]+)/)?.[1];
  console.log('CSRF attuale:', token);
  return config;
});

export default instance;

